module.exports = __webpack_public_path__ + "img/from_left.918901e9.png";